import { render, staticRenderFns } from "./AddModel.vue?vue&type=template&id=2ef192f2&scoped=true"
import script from "./AddModel.vue?vue&type=script&lang=js"
export * from "./AddModel.vue?vue&type=script&lang=js"
import style0 from "./AddModel.vue?vue&type=style&index=0&id=2ef192f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef192f2",
  null
  
)

export default component.exports